var _defs, _rect, _text, _rect2, _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _polyline, _rect3, _path21, _path22, _rect4, _rect5, _rect6, _text2, _polygon, _circle, _circle2, _text3, _circle3, _circle4, _text4, _circle5, _circle6, _text5, _rect7, _circle7, _circle8, _circle9, _circle0, _polygon2, _polyline2, _line, _line2, _line3, _line4, _circle1, _polygon3, _path23, _path24, _path25, _path26, _path27, _path28, _circle10, _circle11, _circle12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaidadverstising6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1600 326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-14,.cls-16,.cls-18,.cls-24,.cls-25,.cls-29,.cls-30,.cls-31{fill:none;}.cls-2{fill:#d8c4df;}.cls-3{font-size:70px;}.cls-20,.cls-21,.cls-22,.cls-23,.cls-3,.cls-8{fill:#2f2143;}.cls-20,.cls-21,.cls-22,.cls-23,.cls-3{font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-4{fill:#aad3f1;}.cls-5{fill:#544741;}.cls-6{clip-path:url(#clip-path);}.cls-7{fill:#c7b299;}.cls-9{clip-path:url(#clip-path-2);}.cls-10{fill:#5e443c;}.cls-11{fill:#fabba2;}.cls-12{fill:#ffc20e;}.cls-13{fill:#e3987d;}.cls-14{stroke:#ffc20e;stroke-width:0.25px;}.cls-14,.cls-16,.cls-18,.cls-24,.cls-25,.cls-29,.cls-30,.cls-31{stroke-miterlimit:10;}.cls-15{fill:#fff;}.cls-16{stroke:#544741;stroke-width:0.99px;}.cls-17{fill:#9a499c;}.cls-18,.cls-25{stroke:#002f3e;}.cls-18{stroke-width:2.96px;}.cls-19{fill:#7ebfe9;}.cls-20{font-size:25px;}.cls-21{font-size:31.19px;}.cls-22{font-size:22.96px;}.cls-23{font-size:15.83px;}.cls-24{stroke:#2f2143;stroke-width:5.96px;}.cls-25{stroke-width:2.79px;}.cls-26{fill:#263238;}.cls-27{fill:#fdc435;}.cls-28{fill:#daa228;}.cls-29,.cls-30,.cls-31{stroke:#9a499c;}.cls-29{stroke-width:2px;}.cls-30{stroke-width:1.37px;}.cls-31{stroke-width:1.99px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.58,291.33l-4.13,28.37H204.9a14.67,14.67,0,0,0-3.39-8.21A16.28,16.28,0,0,0,189.24,306a21.46,21.46,0,0,1-6.47-.29,20.67,20.67,0,0,1-2.39-.65,28,28,0,0,1,0-7.69,27.62,27.62,0,0,1,1.52-6.06Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.1,293l15.09,24.37L260.68,290a14.7,14.7,0,0,0-7.87-4.1,16.25,16.25,0,0,0-12.91,3.72,22,22,0,0,1-5.14,3.94,20.15,20.15,0,0,1-2.25,1,27.8,27.8,0,0,1-5-5.85,27.32,27.32,0,0,1-2.73-5.62Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PAID ADVERSTISING 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 1600,
    height: 326
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(504.24 214.62)"
  }, "PAID ADVERTISING")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 682.22,
    y: 25.06,
    width: 244.87,
    height: 109.68,
    rx: 18.86
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M204.9,319.7H162.45l4.13-28.37h15.27a27.7,27.7,0,0,0-1.47,13.75,20.67,20.67,0,0,0,2.39.65,21.46,21.46,0,0,0,6.47.29,16.28,16.28,0,0,1,12.27,5.47,14.67,14.67,0,0,1,3.39,8.21",
    transform: "translate(0 0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "163.02 315.77 190.42 315.77 196.93 307.91 211.27 307.91 208.05 320.79 159.72 321.95 163.02 315.77"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M99.9,318.83h0a3.49,3.49,0,0,0,4.12-2.67l16.61-78.34a3.47,3.47,0,0,0-6.79-1.44L97.23,314.72a3.48,3.48,0,0,0,2.67,4.11",
    transform: "translate(0 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M130.37,321h0a3.48,3.48,0,0,0,3.47-3.47V237.42a3.48,3.48,0,0,0-7,0V317.5a3.49,3.49,0,0,0,3.48,3.47",
    transform: "translate(0 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M159.64,319.63h0a3.47,3.47,0,0,0,2.74-4.07L146.9,237a3.47,3.47,0,0,0-6.81,1.34l15.48,78.57a3.48,3.48,0,0,0,4.07,2.73",
    transform: "translate(0 0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M260.68,290l-32.49,27.33L213.1,293l11.69-9.83a27.51,27.51,0,0,0,7.72,11.47,19.36,19.36,0,0,0,2.25-1,22,22,0,0,0,5.14-3.94,16.25,16.25,0,0,1,12.91-3.72,14.7,14.7,0,0,1,7.87,4.1",
    transform: "translate(0 0)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "226.1 313.94 247.07 296.3 247 286.1 257.98 276.87 263.8 288.8 227.56 320.8 226.1 313.94"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M151.56,238.64H107.4a4,4,0,0,1,0-7.92h44.16a4,4,0,1,1,0,7.92",
    transform: "translate(0 0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M150.57,231.54l33.59,21.58,26.51,47.39,26.22-17.74S218,245.92,198.76,233.28Z",
    transform: "translate(0 0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M152.31,66.09c2.37-.08,4.81,5.49,5.58,7.26,3.46,7.91,1.48,15.42.66,18l-2.68,4.42a20,20,0,0,1,6.93,12.6c1.22,10-6.26,16.77-6.93,17.36a9.12,9.12,0,0,1-4.65,1.62c-3.94.18-7.84-2.48-10-6.75C145.15,75.74,149.24,66.19,152.31,66.09Z",
    transform: "translate(0 0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M154,298l41.77,2.25,3-65.16a25.07,25.07,0,0,0-3.57-13.52c-4.05-6.62-10.38-9.12-13.57-10.36-2.06-.8-4.81-1.62-19.63-2.44-5.48-.31-10-.47-13.24-.56L99.65,206s-4.56,24.31,21.26,25.8l43.48,4.48Z",
    transform: "translate(0 0)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M142.17,118.72s-.57-7.23.77-11.15c0,0,14.42,2.92,14.21-12.25,0,0,3.24-2.12,3-4.78,0,0-4.81-1.31-4.94-8.87,0,0,1.13-7.52-2.88-12.08,0,0-39.16-22-27,46.21Z",
    transform: "translate(0 0)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M150.5,127.42l-4.93,24.69s15.9,15.63,21,18.56c0,0,2.35,2,7.4,1.39l43.05-6.8L216,151l-39.25,5.81Z",
    transform: "translate(0 0)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M101.2,206.86,150.63,209s7.13-68.19,4.05-75.65c0,0-.51-6-7.8-13.45l-24.48-7.72s-12.44,7.89-14.91,28.52l-10.25,56s-1,8.16,4,10.16",
    transform: "translate(0 0)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M228.76,152.86l2,2.08c.05.09,1.15,2,.67,2.44s-1.57-.21-3-1.37c-.7-.71-1.39-1.43-2.08-2.14Z",
    transform: "translate(0 0)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M231.66,150l2,2.08c.05.09,1.15,2,.67,2.45s-1.58-.21-3-1.37L229.26,151Z",
    transform: "translate(0 0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M234.51,149.58l2,2.09c.05.08,1.15,2,.67,2.44s-1.57-.21-3-1.37l-2.08-2.15Z",
    transform: "translate(0 0)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M213.89,159.18l5-2s9.55,3.36,13.24-1.06c0,0,1-1.16-6.81-1.19a15.54,15.54,0,0,1,9.56-4.39,11.53,11.53,0,0,1,3.29,1.32s3.63,1.12,1.51-1.49c0,0-3.19-3.27-6-3s-19.07,3.73-19.07,3.73l-.23.06Z",
    transform: "translate(0 0)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M210,167l5-2s9.55,3.36,13.24-1.06c0,0,.95-1.16-6.81-1.19a15.58,15.58,0,0,1,9.55-4.4,11.82,11.82,0,0,1,3.29,1.32s3.63,1.13,1.52-1.48c0,0-3.2-3.28-6-3s-19.07,3.73-19.07,3.73l-.23.06Z",
    transform: "translate(0 0)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M121.83,122.84c-5.38,1-7,5.33-10,4.73-1.12-.23-2.61-1.18-4-4.63a6.48,6.48,0,0,1-8.3.48,6.09,6.09,0,0,1-2-5.91,6.22,6.22,0,0,1,2.15-3.45,11,11,0,0,1-4.25-4.64c-2.51-5.39,1-11,1.93-12.28a15.48,15.48,0,0,1,7.82-5.77A11.55,11.55,0,0,1,117,79.43a20.07,20.07,0,0,1,.49-4.89A20.47,20.47,0,0,1,120,68.48,22.43,22.43,0,0,1,134.1,59.7c10.15-1.68,17.42,4.62,18.35,5.46,0,0,3.53,16.31-14.8,23,0,0,11,20-3,21.26-1.25,9.78-4,12.67-6.31,13.46S125.2,122.23,121.83,122.84Z",
    transform: "translate(0 0)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M161.3,155.15l-26-26.12a11.33,11.33,0,0,0-5.21-2c-.31,0-5.38-.57-8.93,2.85S117,139,119.63,144c0,0,16.4,18.7,31.24,25.09,0,0,1.17,4.93,10.95,3.46a140.21,140.21,0,0,0,52.07-6.78l-1.19-8.27s-49.51-1.53-51.4-2.33",
    transform: "translate(0 0)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M116.16,207.52s-11.85,21.55,65.12,21.4l-8.23,62.86",
    transform: "translate(0 0)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M159.72,291.33c.58-.14,32.44,2.18,32.44,2.18",
    transform: "translate(0 0)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M147,96.73l7.12.5s-.49,5.74-3.56,5c0,0-3.18-.48-3.56-5.55",
    transform: "translate(0 0)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "152.39 84.23 150.35 84.23 152.04 85.72"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 255.08,
    y: 125.37,
    width: 5.6,
    height: 59.06,
    transform: "translate(97.46 -99.58) rotate(26.78)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M152.77,292.64c0,2.82-10.15,5.11-22.68,5.11s-22.69-2.29-22.69-5.11,10.16-5.12,22.69-5.12S152.77,289.81,152.77,292.64Z",
    transform: "translate(0 0)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M334,188.94H167.5a5.06,5.06,0,0,1,0-10.11H334a5.06,5.06,0,1,1,0,10.11",
    transform: "translate(0 0)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 314.57,
    y: 188.94,
    width: 8.87,
    height: 137.06
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 197.43,
    y: 176.35,
    width: 51.5,
    height: 2.48
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 809.98,
    y: 64.63,
    width: 66.5,
    height: 30.53,
    rx: 11.82
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-20",
    transform: "translate(820.29 88.66)"
  }, "ADS")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "844.68 102.64 836.37 111.01 840.85 111.01 840.85 125.04 848.51 125.04 848.51 111.01 853.22 111.01 844.68 102.64"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 438.27,
    cy: 113.84,
    r: 23.13
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 438.27,
    cy: 113.84,
    r: 19.99
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-21",
    transform: "translate(429.54 124.9)"
  }, "$")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 728.19,
    cy: 277.74,
    r: 17.03
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 728.19,
    cy: 277.74,
    r: 14.72
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-22",
    transform: "translate(721.76 285.88)"
  }, "$")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 736.27,
    cy: 83.77,
    r: 11.74
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 736.27,
    cy: 83.77,
    r: 10.15
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(731.84 89.38)"
  }, "$")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 803.8,
    y: 32.28,
    width: 110.08,
    height: 7.36,
    rx: 3.68
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 712.93,
    cy: 35.96,
    r: 3.65
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 724.53,
    cy: 35.96,
    r: 3.65
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 736.27,
    cy: 35.96,
    r: 3.65
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 1424.27,
    cy: 69.13,
    r: 31.96
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1441.69 69.13 1413.18 52.66 1413.18 85.59 1441.69 69.13"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-25",
    points: "1249.7 263.01 1249.7 282.66 1306.39 282.66 1306.39 201.92 1249.7 201.92 1249.7 227.41"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 1255.66,
    y1: 229.79,
    x2: 1285.14,
    y2: 229.79
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 1263.74,
    y1: 239.94,
    x2: 1297.11,
    y2: 239.94
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 1256.91,
    y1: 260.68,
    x2: 1299.18,
    y2: 260.68
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 1264.05,
    y1: 250.31,
    x2: 1296.79,
    y2: 250.31
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 1247.06,
    cy: 245.62,
    r: 17.88,
    transform: "matrix(0.92, -0.38, 0.38, 0.92, 0.93, 495.92)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "1255.68 246.9 1242.6 239.34 1242.6 254.45 1255.68 246.9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1448.74,299.46l4.91-1.49a5.94,5.94,0,0,0,4.08-6.44l-5.37-39.3L1439,256.36l2.17,37.82a5.84,5.84,0,0,0,6.11,5.55,5.37,5.37,0,0,0,1.49-.27",
    transform: "translate(0 0)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1416.56,248.28c-.73-2.3-1.41-4.56-2-6.82a38.77,38.77,0,0,1,12.22-11.35c1.53,4.35,3,8.92,4.51,13.62s2.76,9.32,3.93,13.8a39.15,39.15,0,0,1-16.5-2.5c-.73-2.23-1.45-4.46-2.13-6.75",
    transform: "translate(0 0)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1425.42,245.56a82.46,82.46,0,0,1-3.56-16.95l43.92-13.56,10.11,32.83-44,13.59a84,84,0,0,1-6.51-15.91",
    transform: "translate(0 0)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1454.51,215.57c2-.64,51-46.15,56.33-47.93s17,17.86,25,43.86,9.81,48.5,4,50.3-71.51-8.49-73.53-7.9-6.9-7.3-10.16-17.9-4.16-19.72-1.66-20.43",
    transform: "translate(0 0)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1514.89,217.93c8,26,19.21,45.63,25,43.87s4-24.15-4-50.3-19.21-45.63-25-43.86-4,24.32,4.05,50.29",
    transform: "translate(0 0)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1528.68,213.62c.53,1.73,1,3.53,1.51,5.12a41.79,41.79,0,0,1-12,9.41c-1.16-3.26-2.31-6.69-3.42-10.22s-2-7.07-3-10.38a41.52,41.52,0,0,1,15.26,1,22.35,22.35,0,0,1,1.66,5.06",
    transform: "translate(0 0)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 1234.37,
    cy: 99.53,
    r: 19.63
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 336.52,
    cy: 52.66,
    r: 13.42
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 411.51,
    cy: 258.21,
    r: 19.53
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidadverstising6);
export default __webpack_public_path__ + "static/media/PAID ADVERSTISING 6.46b9c4d7bdcf591ef6a8051e69b95ba3.svg";
export { ForwardRef as ReactComponent };